<template>
    <div class="main-panel">
        <top-navbar></top-navbar>
        <div class="content">
            <div class="row">
                <div class="col-md-6 rolelist">
                    <div class="">
                        <h5 class="">Name: {{this.user.name}}, Number: {{this.user.number}}, Email: {{this.user.email}}</h5>
                    </div>
                </div>
        
                <div class="col-md-12 rolelistupper">
                    <div class="card">
                        <FlashMessage :position="'right top'"></FlashMessage>
    
                        <div class="card-body table-responsive table-full-width">
    
                            <table class="table table-borderd mt-5" id="myTable">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Category</th>
                                        <th>Subcategory</th>
                                        <th>Product</th>
                                        <th>Image</th>
                                        <th>Stock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="data in tableData" v-bind:key="data.wishlistid">
                                        <td>{{data.wishlistid}}</td>
                                        <td>{{data.categoryname}}</td>
                                        <td>{{data.subcategoryname}}</td>
                                        <td>{{data.productname}}</td>
                                        <td><img :src="api+'/storage/image/'+data.singleimage" height="50px" width="50px"></td>
                                        <td v-if="data.quantity == 0">Stock Out</td>
                                        <td v-else>In Stock</td>
                
                                    </tr>
                                </tbody>
    
                            </table>
    
                        </div>
                    </div>
                </div>
            </div>
    
        </div>
        <content-footer></content-footer>
    </div>
    </template>
    
    <script>
    import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
    import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
    import datatable from "datatables.net-bs4"
    import Auth from '../../../Auth.js';
    import Vue from 'vue'
    import $ from "jquery"
    import {
        Table,
        TableColumn
    } from 'element-ui'
    Vue.use(Table)
    Vue.use(TableColumn)
    export default {
        name: 'wishlist-detail',
    
        components: {
            TopNavbar,
            ContentFooter,
        },
    
        data() {
            return {
                tableData: [],
                user:'',
                Auth: '',
            api: process.env.VUE_APP_API_BASE_URL,

            }
        },
    
        methods: {
    
            table() {
                this.$nextTick(() => {
                    $('#myTable').DataTable();
                });
            },
        },
    
        async mounted() {
            this.Auth = Auth.user;
            const wishlistdata = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/wishlist/` + this.$route.params.id);
            this.tableData = wishlistdata.data;
            this.user=wishlistdata.data[0];
            let i = 0;
                let a = [];
                for (i = 0; i < wishlistdata.data.length; i++) {
                    a = wishlistdata.data[i].productimage.toString().split('|');
                    this.tableData[i].singleimage =a[0];
                }
            this.table();
        },
    
    };
    </script>
    
    <style lang="scss">
    
    </style>
    